module.exports = __webpack_public_path__ + "static/media/author-Esme.0280cc71.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/author-Esme.png
// module id = 1559
// module chunks = 1